import Storage from './index';

class SiteStorage extends Storage {
  constructor() {
    super('Site');
  }
}

export default new SiteStorage();
